import { render, staticRenderFns } from "./AccountRisks.vue?vue&type=template&id=4d2b487e&scoped=true&"
import script from "./AccountRisks.vue?vue&type=script&lang=js&"
export * from "./AccountRisks.vue?vue&type=script&lang=js&"
import style0 from "./AccountRisks.vue?vue&type=style&index=0&id=4d2b487e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b487e",
  null
  
)

export default component.exports